import { render, staticRenderFns } from "./airlineCard.vue?vue&type=template&id=2759e283&"
import script from "./airlineCard.vue?vue&type=script&lang=js&"
export * from "./airlineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports